import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const SearchIcon = (props: IIconProps) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.8751 18.7535C15.2252 18.7535 18.7516 15.227 18.7516 10.8769C18.7516 6.52682 15.2252 3.00037 10.8751 3.00037C6.52498 3.00037 2.99854 6.52682 2.99854 10.8769C2.99854 15.227 6.52498 18.7535 10.8751 18.7535Z" stroke={color} strokeWidth="1.50029" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16.449 16.4462L21.0061 21.0033" stroke={color} strokeWidth="1.50029" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default memo(SearchIcon);
